import React from 'react';
import config from 'react-global-configuration';
//import SubCategorias from './SubCategorias';
import firebase from './../Firestore'
import store from '../../store';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';


class FormularioDatosCliente extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  constructor(props) {
    super(props);

    const { cookies } = props;
    this.state = {
        usuarioNombre: cookies.get('usuarioNombre'),
        usuarioTelefono: cookies.get('usuarioTelefono'),
        usuarioFormaEntrega: "Delivery",
        usuarioMomentoEntrega: "Inmediata",
        usuarioProgramarEntrega: "",
        usuarioDireccion: cookies.get('usuarioDireccion')? cookies.get('usuarioDireccion') :"",
        usuarioAclaraciones: ""
     };


  }


envioFormulario(e){


  switch (e.target.name) {
    case "confirma":
      e.preventDefault();
      //console.log("confirmo");
      this.agregaPedidoBaseDatos();
      break;
    case "usuarioNombre":
    this.setState({ usuarioNombre:  e.target.value })
      break;
    case "usuarioTelefono":
    if(!isNaN(e.target.value) && e.target.value.length <= 15) {
      let res = e.target.value.substring(e.target.value.length - 15, e.target.value.length).trim();
      //res = res.slice(-15, -8) +"-"+ res.slice(-8, -4) +"-"+ res.slice(-4);
      this.setState({ usuarioTelefono: res })
    }

      break;
    case "usuarioFormaEntrega":
    this.setState({ usuarioFormaEntrega: e.target.value })
      break;
    case "usuarioMomentoEntrega":
    this.setState({ usuarioMomentoEntrega: e.target.value })
      break;
    case "usuarioProgramarEntrega":
    this.setState({ usuarioProgramarEntrega: e.target.value })
      break;
    case "usuarioDireccion":
    this.setState({ usuarioDireccion: e.target.value })
      break;
    case "usuarioAclaraciones":
    this.setState({ usuarioAclaraciones: e.target.value })
      break;
    default:
  }


}

agregaPedidoBaseDatos(e){

  const currentComponent = this;
  var db = firebase.firestore()
  db.collection("pedido").doc(sessionStorage.getItem("nroPedido")).set({
      estado: "ingresado",
      fecha: new Date(),
      total: Number(this.props.total),
      uid: this.props.uid,
      formaEntrega: this.state.usuarioFormaEntrega,
      momentoEntrega: this.state.usuarioMomentoEntrega,
      usuarioProgramarEntrega: this.state.usuarioProgramarEntrega,
      clienteNombre: this.state.usuarioNombre,
      clienteTelefono: this.state.usuarioTelefono,
      clienteDireccion: this.state.usuarioDireccion,
      usuarioAclaraciones: this.state.usuarioAclaraciones,
      enProceso: true
  })
  .then(function() {
      console.log("Document successfully written!");
      // eliminar el pedidoId en la sesion una vez ingresado en la db

      const { cookies } = currentComponent.props;

      cookies.set('usuarioNombre', currentComponent.state.usuarioNombre, { path: '/', maxAge: 2500000 });
      cookies.set('usuarioTelefono', currentComponent.state.usuarioTelefono, { path: '/', maxAge: 2500000 });
      cookies.set('usuarioDireccion', currentComponent.state.usuarioDireccion, { path: '/', maxAge: 2500000 });
      cookies.set('nroPedidoMasReciente', sessionStorage.getItem("nroPedido"), { path: '/', maxAge: 18000 });
      cookies.set('fechaHoraPedidoMasReciente', new Date(), { path: '/', maxAge: 18000 });
      cookies.set('estadoPedidoMasReciente', "ingresado", { path: '/', maxAge: 18000 });


      sessionStorage.removeItem("nroPedido");
      currentComponent.setState({productosEnCarrito: []});
      store.dispatch({
        type: "COMPRA_COMPLETADA",
        vieneDelCarrito: true
      })

  })
  .catch(function(error) {
      console.error("Error writing document: ", error);
  });
}




render() {
    const classRadioSeleccionado = "badge badge-secondary";
    const classRadioNoSeleccionado = "";

    return (
      <div className="bg-light mx-2 p-1 rounded">
        <h5>Completa con tus datos para finalizar el pedido</h5>
        <form>
          <div className="form-group row">
            <label htmlFor="inputNombre3" className="col-sm-2 col-form-label"><strong>Nombre</strong></label>
            <div className="col-sm-10">
              <input type="text" value={this.state.usuarioNombre} name="usuarioNombre" onChange={event => this.envioFormulario(event)} className="form-control" id="inputNombre3" placeholder="Nombre" required />
            </div>
          </div>


            <div className="form-group row">
              <label htmlFor="inputTelefono3" className="col-sm-2 col-form-label"><strong>Telefono celular</strong></label>
              <div className="col-sm-10">
                <input type="text" size="15" value={this.state.usuarioTelefono} name="usuarioTelefono" onChange={event => this.envioFormulario(event)} className="form-control" id="inputTelefono3" placeholder="Celular" required/>
              </div>
              <p className="mx-3"><small>Ingrese el número de su celular.</small>
                {!this.state.usuarioTelefono &&
                  <span className="mt-0 d-block text-primary"><small>Quedará registrad@ como cliente y será su identificacion para los próximos pedidos.</small></span>
                }
              </p>
            </div>


          <fieldset className="form-group">
            <div className="row">
              <legend className="col-form-label col-sm-2 pt-0"><strong>Forma de entrega</strong></legend>
              <div className="col-sm-10">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" onChange={event => this.envioFormulario(event)} name="usuarioFormaEntrega" id="gridRadios1" value="Delivery" checked={this.state.usuarioFormaEntrega === "Delivery"? true : false} />
                  <label className="form-check-label" htmlFor="gridRadios1">
                    <span className={this.state.usuarioFormaEntrega === "Delivery"? classRadioSeleccionado : classRadioNoSeleccionado}>Delivery a mi domicilio</span>
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" onChange={event => this.envioFormulario(event)} name="usuarioFormaEntrega" id="gridRadios2" value="Retira" checked={this.state.usuarioFormaEntrega === "Retira"? true : false}/>
                  <label className="form-check-label" htmlFor="gridRadios2">
                    <span className={this.state.usuarioFormaEntrega === "Retira"? classRadioSeleccionado : classRadioNoSeleccionado}>Retiro por el local</span>
                  </label>
                </div>
              </div>
            </div>
          </fieldset>

          {this.state.usuarioFormaEntrega === "Delivery" ? (
            <div className="form-group row">
              <label htmlFor="inputDireccion3" className="col-sm-2 col-form-label"><strong>Direccion</strong></label>
              <div className="col-sm-10">
                <input type="text" value={this.state.usuarioDireccion} name="usuarioDireccion" onChange={event => this.envioFormulario(event)} className="form-control" id="inputDireccion3" placeholder="Dirección donde se entrega" required />
              </div>
            </div>
           ) : (
             <p>Lugar por donde retirará el pedido: <strong>{ config.get('tienda').direccion }</strong></p>
           )}

           <fieldset className="form-group">
             <div className="row">
               <legend className="col-form-label col-sm-2 pt-0"><strong>Entregar...</strong></legend>
               <div className="col-sm-10">
                 <div className="form-check form-check-inline">
                   <input className="form-check-input" type="radio" onChange={event => this.envioFormulario(event)} name="usuarioMomentoEntrega" id="usuarioMomentoEntrega1" value="Inmediata" checked={this.state.usuarioMomentoEntrega === "Inmediata"? true : false} />
                   <label className="form-check-label" htmlFor="usuarioMomentoEntrega1">
                     <span className={this.state.usuarioMomentoEntrega === "Inmediata"? classRadioSeleccionado : classRadioNoSeleccionado}>Lo antes posible</span>
                   </label>
                 </div>
                 <div className="form-check form-check-inline">
                   <input className="form-check-input" type="radio" onChange={event => this.envioFormulario(event)} name="usuarioMomentoEntrega" id="usuarioMomentoEntrega2" value="Programar" checked={this.state.usuarioMomentoEntrega === "Programar"? true : false}/>
                   <label className="form-check-label" htmlFor="usuarioMomentoEntrega2">
                     <span className={this.state.usuarioMomentoEntrega === "Programar"? classRadioSeleccionado : classRadioNoSeleccionado}>Indicar día y hora</span>
                   </label>
                 </div>
               </div>
             </div>
           </fieldset>

           {this.state.usuarioMomentoEntrega === "Programar" &&

             <div className="form-group row">
               <label htmlFor="inputProgramarEntrega3" className="col-sm-2 col-form-label">Indicar día y hora para la entrega</label>
               <div className="col-sm-10">
                 <input type="text" value={this.state.usuarioProgramarEntrega} name="usuarioProgramarEntrega" onChange={event => this.envioFormulario(event)} className="form-control" id="inputProgramarEntrega3" placeholder="Programar día y hora para la entrega" required />
             </div>
             </div>

           }

          <div className="form-group row">
             <label htmlFor="usuarioAclaraciones" className="col-sm-2 col-form-label">Aclaraciones (opcional)</label>
                <div className="col-sm-10">
                  <textarea className="w-100 form-control" value={this.state.usuarioAclaraciones} id="usuarioAclaraciones" name="usuarioAclaraciones" onChange={event => this.envioFormulario(event)} />
                </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-10">
              <button name="confirma" className="btn btn-lg btn-block btn-success" onClick={event => this.envioFormulario(event)}>Confirmar pedido</button>
            </div>
          </div>
        </form>
      </div>


    )
  }

}
export default withCookies(FormularioDatosCliente);
